import { TourConfig } from '../models/tour-config.model';
import { TourFeature } from '../config/tour-feature.enum';
import { Audience } from '../config/audience.enum';
import { TourTrigger } from '../config/trigger.enum';
import { AnchorId } from '../config/anchor.registry';

/**
 * Kontextuelle Hilfe-Tour fuer die Seite "Schichtplanung"
 * (`/settings/shift`). Wird ueber den `?`-Button im Settings-Sticky-Header
 * gestartet.
 *
 * Fuenf Schritte:
 *  1. Welcome + Planungs-Section (Spotlight auf .planning)
 *  2. Master-Schalter "Schichtplanung aktiv"
 *  3. Schichttausch erlauben
 *  4. Vorlaufzeit fuer Tausch (Days-In-Advance)
 *  5. KI-Optimierung (skipIf wenn Feature nicht freigeschaltet)
 *
 * Tour-Texte in `de.json/en.json` unter `TUTORIAL.SETTINGS_SHIFT.*`,
 * Voice-Over-Manifest unter `settings-shift-help`.
 */
export const SETTINGS_SHIFT_HELP_TOUR: TourConfig = {
  id: TourFeature.SettingsShiftHelp,
  version: 1,
  title: 'SETTINGS_SHIFT_HELP_TOUR_TITLE',
  description: 'SETTINGS_SHIFT_HELP_TOUR_DESC',
  audience: [Audience.Admin, Audience.TeamLeader],
  triggers: [TourTrigger.Manual],
  triggerContext: { route: '/settings/shift' },
  statePolicy: {
    allowReplay: true,
    snoozeEnabled: false,
    cooldownHoursAfterDismiss: 0,
    cooldownHoursAfterSnooze: 0,
    suppressAfterCompletion: false,
  },
  priority: 100,
  estimatedDurationSec: 90,
  category: 'feature-discovery',
  chapters: [
    {
      id: 'overview',
      title: 'SETTINGS_SHIFT_HELP_TOUR_TITLE',
      steps: [
        {
          id: 'welcome',
          anchor: AnchorId.ShiftSettingsPlanning,
          spotlightAnchor: AnchorId.ShiftSettingsPlanning,
          title: 'TUTORIAL.SETTINGS_SHIFT.WELCOME.TITLE',
          content: 'TUTORIAL.SETTINGS_SHIFT.WELCOME.CONTENT',
          placement: 'bottom',
          nextCondition: 'manual',
          showNextButton: true,
          showPrevButton: false,
        },
        {
          id: 'master-switch',
          anchor: AnchorId.ShiftSettingsActive,
          spotlightAnchor: AnchorId.ShiftSettingsActive,
          title: 'TUTORIAL.SETTINGS_SHIFT.MASTER_SWITCH.TITLE',
          content: 'TUTORIAL.SETTINGS_SHIFT.MASTER_SWITCH.CONTENT',
          placement: 'right',
          nextCondition: 'manual',
          showNextButton: true,
        },
        {
          id: 'allow-swap',
          anchor: AnchorId.ShiftSettingsAllowSwap,
          spotlightAnchor: AnchorId.ShiftSettingsSwap,
          title: 'TUTORIAL.SETTINGS_SHIFT.ALLOW_SWAP.TITLE',
          content: 'TUTORIAL.SETTINGS_SHIFT.ALLOW_SWAP.CONTENT',
          placement: 'right',
          nextCondition: 'manual',
          showNextButton: true,
        },
        {
          id: 'days-in-advance',
          anchor: AnchorId.ShiftSettingsDaysInAdvance,
          spotlightAnchor: AnchorId.ShiftSettingsDaysInAdvance,
          title: 'TUTORIAL.SETTINGS_SHIFT.DAYS_IN_ADVANCE.TITLE',
          content: 'TUTORIAL.SETTINGS_SHIFT.DAYS_IN_ADVANCE.CONTENT',
          placement: 'right',
          nextCondition: 'manual',
          showNextButton: true,
        },
        {
          id: 'ai-optimization',
          anchor: AnchorId.ShiftSettingsAi,
          spotlightAnchor: AnchorId.ShiftSettingsAi,
          title: 'TUTORIAL.SETTINGS_SHIFT.AI.TITLE',
          content: 'TUTORIAL.SETTINGS_SHIFT.AI.CONTENT',
          placement: 'right',
          nextCondition: 'manual',
          showNextButton: true,
          showPrevButton: true,
          // KI-Toggle existiert nur wenn `hasShiftPlanningBasic` true ist —
          // ohne Basic-Feature ist der gesamte Toggle ausgeblendet.
          skipIf: () =>
            !document.querySelector('[onboardingAnchor="shift-settings-ai"]'),
        },
      ],
    },
  ],
};
